import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FileSaver from "file-saver";
import i18n from "i18n";

import { OrderService } from "../../../../../services/OrderService";
// import { EventRepository } from 'helpers/EventRepository';
import { EventRepository } from "helpers/EventRepository";

import styles from "./RelocationOrderDetail.module.scss";
import AdminLayout from "../../../../../components/MainApp/layouts/DesktopLayout";
import OrderDetailDescriptionPanel from "../../../../../components/MainApp/organisms/Orders/RequestOrders/Detail/Description";
import OrderProductSummary from "../../../../../components/MainApp/organisms/Orders/RequestOrders/ProductSummary";
import OrderPills from "../../../../../components/MainApp/atoms/Pills/OrderPills";
import MainButton from "../../../../../components/MainApp/atoms/RoundedButton";
import RejectModal from "../../../../../components/MainApp/organisms/Orders/RequestOrders/Modals/RejectModal";
import TwoOptionModal from "../../../../../components/MainApp/atoms/Modals/TwoOptionModal";
import Loader from "../../../../../components/MainApp/atoms/Loader";
import { isMobile } from "../../../../../helpers/Mobile";
import { ParseDateTime } from "helpers/Parsers";
import { capitalize } from "helpers/utils/utils_general";

export const RelocationOrderDetailsView = props => {
  const history = useHistory();

  const [order, setOrder] = useState(null);
  const [orderDescription, setorderDescription] = useState([]);
  const [modalOpen, setmodalOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [products, setproducts] = useState([]);
  const [recOrder, setRecOrder] = useState({});

  const headerOptions = isMobile
    ? [
        {
          icon: "icon-iconos_descargar",
          name: "Descargar",
          handler: () => {
            alert("hi");
          },
          tooltip: i18n.t("download")
        }
      ]
    : [];

  const goBackModal = () => {
    history.push("/admin/orders/relocation");
  };

  useEffect(() => {
    const id = props.match.params.key;
    setloading(true);
    OrderService.relocationOrder(id).then(response => {
      setloading(false);
      setOrder(response);
      const orderDescriptionNew = formatOrderForDescription(response);
      setorderDescription(orderDescriptionNew);

      if (["DISP", "COM"].includes(response.status)) {
        OrderService.recOrders({ initial_order: response.id }).then(
          response => {
            if (response.results.length > 0) {
              setRecOrder(response.results[0]);
            }
          }
        );
      }else if(response.status === 'REJ'){
        OrderService.getOrderStatus(response.id).then(response => {
          const orders = Object.values(response).filter(item => typeof item === 'object' && item !== null);
          let reason = orders.reduce((r, order) => order?.reason || r, '');
          // Añadir el nuevo elemento con title: "Motivo" y el valor encontrado
          const orderDescriptionNew2 = [
            ...orderDescriptionNew,
            { title: i18n.t("reason"), value: reason }
          ];
          setorderDescription(orderDescriptionNew2);
        });
      }
    });
  }, []);

  useEffect(() => {
    const id = props.match.params.key;
    OrderService.getItems(id).then(response => {
      let productList = response.map(item => {
        let newItem;
        newItem = item.item;
        newItem.units = item.quantity;
        newItem.code = item.item.sku;

        newItem.stock = 1;
        return item.item;
      });
      setproducts(productList);
    });
  }, []);

  const formatOrderForDescription = newOrder => {
    return [
      {
        title: i18n.t("order.number"),
        value: newOrder.code
      },
      {
        title: capitalize(i18n.t("creation.date")),
        value: new Date(newOrder.created_at).toLocaleString(),
      },
      {
        title: i18n.t("origin"),
        value: newOrder["origin"] && newOrder["origin"].name
      },
      {
        title: i18n.t("destination"),
        value: newOrder["destination"] && newOrder["destination"].name
      },
      {
        title: i18n.t("owner"),
        value: newOrder["owner"] && newOrder["owner"].name
      }
    ];
  };

  const handleRejectModalOpen = () => {
    setmodalOpen(true);
  };

  const handleCloseModal = () => {
    setmodalOpen(false);
  };

  const handleReject = reason => {
    setloading(true);
    OrderService.changeOrderStatus(order.id, "REJ", reason)
      .then(response => {
        setmodalOpen(false);
        setloading(false);
        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.rejected"),
          type: "success"
        });
        props.history.push("/admin/orders/relocation");
      })
      .catch(error => {
        EventRepository.notificationSend({
          label: i18n.t("order.rejecting.error"),
          type: "error"
        });
      });
  };

  const handleApprove = () => {
    setloading(true);
    OrderService.changeOrderStatus(order.id, "PRO", "apporoved")
      .then(response => {
        setloading(false);
        setmodalOpen(false);

        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.approved"),
          type: "success"
        });
        props.history.push("/admin/orders/relocation");
      })
      .catch(error => {
        EventRepository.notificationSend({
          label: i18n.t("order.approving.error"),
          type: "error"
        });
      });
  };

  const downloadVoucher = () => {
    setloading(true);
    OrderService.relocationDownloadVoucher(order.id)
      .then(blob => {
        setloading(false);
        FileSaver.saveAs(blob, "comprobante.pdf");
      })
      .catch(error => {
        setloading(false);
      });
  };

  const goToReceptionOrder = () => {
    props.history.push(`/admin/orders/relocation/details/${recOrder.id}/`);
  };

  const customButtons = (
    <div className={styles["relocation-order-details-custom-buttons"]}>
      <div className={styles["relocation-order-details-reject"]}>
        <MainButton
          handleClick={handleRejectModalOpen}
          state={"enabled"}
          legend={i18n.t("decline")}
        ></MainButton>
      </div>

      <div className={styles["relocation-order-details-approve"]}>
        <MainButton
          handleClick={handleApprove}
          state={"enabled"}
          legend={i18n.t("approve")}
        ></MainButton>
      </div>
    </div>
  );

  const loadedContent = (
    <div className={styles["relocation-order-details-wrapper"]}>
      <div className={styles["relocation-order-details-title-wrapper"]}>
        <div className={styles["relocation-order-details-left-title"]}>
          <div className={styles["relocation-order-details-title"]}>
            {i18n.t("receipt.order")}
          </div>
          <div className={styles["pill-wrapper"]}>
            {order && <OrderPills big={true} state={order.status}></OrderPills>}
          </div>
        </div>

        <div className={styles["relocation-order-details-right-title"]}>
          {order && order.status === "DISP" && (
            <div
              style={{ display: "flex", alignItems: "center" }}
              onClick={goToReceptionOrder}
            >
              <i className={`${styles["relocation-order-details-order-rec-icon"]} icon-iconos_documento`}></i>
              <div className={styles["relocation-order-details-order-rec-text"]}>
                {i18n.t("see.receipt.order")}
              </div>
            </div>
          )}
          <div
            style={{ display: "flex", alignItems: "center" }}
            onClick={downloadVoucher}
          >
            <i className={`${styles["relocation-order-details-download-icon"]} icon-iconos_descargar`}></i>
            <div className={styles["relocation-order-details-download-text"]}>
              {i18n.t("download.detail")}
            </div>
          </div>
        </div>
        {!isMobile && order && order.status === "PEN" &&(
          <div className={styles["relocation-order-details-button"]}>
            {customButtons}
          </div>
        )}

      </div>
      <div className={styles["relocation-order-details-panels"]}>
        <div className={styles["relocation-order-details-left"]}>
          <div className={styles["relocation-order-details-panel"]}>
            <OrderDetailDescriptionPanel
              order={orderDescription}
            ></OrderDetailDescriptionPanel>
          </div>
        </div>
        <div className={styles["relocation-order-details-right"]}>
          <div className={styles["relocation-order-details-panel"]}>
            <OrderProductSummary
              products={products}
              edit={false}
              paginationSize={5}
            ></OrderProductSummary>
          </div>
        </div>
      </div>
      {isMobile && order && order.status === "PEN" && (
        <div className={styles["relocation-order-details-button"]}>
          {/* <div className="relocation-order-details-button-inner">
              <MainButton legend={i18n.t("guardar")} type="submit" handleClick={handleApprove} state={"enabled"}></MainButton>
            </div> */}
          {customButtons}
        </div>
      )}
      <RejectModal
        open={modalOpen}
        handleClose={handleCloseModal}
        handleReject={handleReject}
      ></RejectModal>
    </div>
  );

  const content = loading ? <Loader /> : loadedContent;

  return (
    <div className={styles["relocation-order-details-container"]}>
      <AdminLayout
        headerTitle={i18n.t("order.detail")}
        headerOptions={headerOptions}
        content={content}
        goBackFunc={goBackModal}
        navHidden={true}
      ></AdminLayout>
    </div>
  );
};

export default RelocationOrderDetailsView;
